import { CalculatorDescription } from '../../../lib/calculators/calculator-description';
import { CalculatorId } from '../../../lib/calculators/calculator-config';
import { TableDataJSON } from '../../../src/types/table-json';

export const modeCalculatorDescription: CalculatorDescription = {
  id: CalculatorId.MODE,
  title: 'Mode calculator',
  metaTitle: 'Mode Calculator - Find Most Frequent Values in Data',
  description: 'Calculate the mode of a dataset - the value that appears most frequently.',
  metaDescription: 'Free online mode calculator. Find the most frequent value in your dataset with our easy-to-use statistical tool. Analyze data patterns instantly.',
  howTo: {
    title: 'How to calculate mode',
    steps: [
      'Enter your numeric data directly into the data table or upload a CSV file',
      'Use the "Select Data Column" control to choose which column of data to analyze',
      'The calculator will automatically identify the value(s) that appear most frequently',
      'If all values appear with equal frequency, "No mode" will be displayed',
      'For multimodal data, all modes will be listed in the results'
    ],
    graphic: {
      description: 'Visual representation of mode calculation'
    }
  },
  examples: [
    {
      title: 'Finding the mode of test scores',
      description: 'Analyzing the most common score in a class test',
      dataDescription: 'Test scores from a class of 10 students',
      insights: [
        'The mode is 85, appearing 4 times',
        'No mode means all values appear equally often',
        'High frequency of one value suggests clustering',
        'Compare with mean and median for distribution shape'
      ],
      data: TableDataJSON.from({
        columns: [
          { 
            id: 'scores',
            name: 'Test Scores', 
            values: ['85', '90', '85', '88', '92', '85', '91', '88', '86', '85'] 
          }
        ]
      })
    }
  ],
  relatedCalculators: [
    CalculatorId.MEAN,
    CalculatorId.MEDIAN,
    CalculatorId.Histogram
  ]
}; 